/* eslint react/no-array-index-key: 0 */
import React from 'react';
import { stepPlans as pageTexts } from '../../../utils/texts';

const SectionNoCoverage = () => {
  const { noCoverageSection } = pageTexts;

  return (
    <div className="section-no-coverage">
      <div className="container">
        <div className="section-no-coverage-container">
          <h3 className="section-no-coverage-container_title">
            {noCoverageSection.titleSection}
          </h3>
          <ul className="section-no-coverage-container_list">
            {noCoverageSection.list.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p>{noCoverageSection.info}</p>
        </div>
      </div>
    </div>
  );
};

export default SectionNoCoverage;
